import { compose } from "recompose";
import withApiErrorWrapper from "../HandleApiErrorWrapperNonRedux";
import withEnergyStores from "../WithEnergyStores";
import AlertsPageWrapper from "./AlertsPageWrapper";

export default compose(
  withApiErrorWrapper,
  withEnergyStores
)(AlertsPageWrapper);
